module.exports = __webpack_public_path__ + "static/media/obs-favicon.5adb859e.ico";